import { render, staticRenderFns } from "./BaseMultipleLinesTextBox.vue?vue&type=template&id=ec8f0ef4&scoped=true&"
import script from "./BaseMultipleLinesTextBox.vue?vue&type=script&lang=js&"
export * from "./BaseMultipleLinesTextBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultipleLinesTextBox.vue?vue&type=style&index=0&id=ec8f0ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8f0ef4",
  null
  
)

export default component.exports